// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts,js_import_style=legacy_commonjs"
// @generated from file fusebase/app_analytics/v1/event_context.proto (package fusebase.app_analytics.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { proto3 } = require("@bufbuild/protobuf");
const { EventType } = require("./event_type_pb.js");
const { Timestamp } = require("../../../google/protobuf/timestamp_pb.js");

/**
 * @generated from message fusebase.app_analytics.v1.EventContext
 */
const EventContext = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.EventContext",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "org_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "portal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "page_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "page_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fusebase.app_analytics.v1.EventContextFilter
 */
const EventContextFilter = /*@__PURE__*/ proto3.makeMessageType(
  "fusebase.app_analytics.v1.EventContextFilter",
  () => [
    { no: 20, name: "user_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 21, name: "org_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 22, name: "workspace_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 23, name: "portal_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 24, name: "page_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 25, name: "event_types", kind: "enum", T: proto3.getEnumType(EventType), repeated: true },
    { no: 26, name: "session_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 27, name: "search_query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 50, name: "date_from", kind: "message", T: Timestamp },
    { no: 51, name: "date_to", kind: "message", T: Timestamp },
  ],
);


exports.EventContext = EventContext;
exports.EventContextFilter = EventContextFilter;
